import { useMemo } from 'react';

import { CheckboxProps } from '../components/checkbox/Checkbox';

export type SelectAllState = 'all' | 'none' | 'some';

type SelectAllStatesResult = {
  state: SelectAllState;
  checkboxProps: CheckboxProps;
};

export function useSelectAll<T>(
  values: T,
  extractState: (values: T) => SelectAllState,
  changeValues: (checked: boolean) => void
): SelectAllStatesResult {
  const state = useMemo(() => extractState(values), [extractState, values]);

  const checkboxProps: CheckboxProps = useMemo(() => {
    return {
      checked: state === 'all',
      indeterminate: state === 'some',
      onChange: (checked: boolean) => changeValues(checked),
    };
  }, [changeValues, state]);

  return { state, checkboxProps };
}
